import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBan,
  faBoxArchive,
  faCircleCheck,
  faCircleExclamation,
  faCircleXmark,
  faEnvelope,
  faHourglassHalf,
  faLayerGroup,
  faPauseCircle,
  faTableColumns,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

type SideBarItem = {
  label: string;
  route: string;
  icon: IconDefinition;
  activeIcon: string;
  subData?: { label: string; route: string }[];
};

const SideBarData: SideBarItem[] = [
  {
    label: "Dashboard",
    route: "/",
    icon: faTableColumns,
    activeIcon: "",
  },
  {
    label: "Chase List",
    route: "/chaselist",
    icon: faLayerGroup,
    activeIcon: "",
  },
  {
    label: "Awaiting Customer",
    route: "/chase/Awaiting-Customer",
    icon: faHourglassHalf,
    activeIcon: "",
  },
  {
    label: "On-Hold",
    route: "/chase/On-Hold",
    icon: faPauseCircle,
    activeIcon: "",
  },
  {
    label: "Debt-Collectors",
    route: "/chase/Debt-Collectors",
    icon: faCircleExclamation,
    activeIcon: "",
  },
  {
    label: "Collected",
    route: "/chase/Collected",
    icon: faCircleCheck,
    activeIcon: "",
  },
  {
    label: "Failed",
    route: "/chase/Failed",
    icon: faCircleXmark,
    activeIcon: "",
  },
  {
    label: "Chargebacks",
    route: "/chase/Chargebacks",
    icon: faBan,
    activeIcon: "",
    subData: [],
  },
  {
    label: "Customer Archives",
    route: "/customer-archives",
    icon: faBoxArchive,
    activeIcon: "",
  },
  {
    label: "My Customers",
    route: "/my-customers",
    icon: faUsers,
    activeIcon: "",
  },

  {
    label: "Agents",
    route: "/agents",
    icon: faUser,
    activeIcon: "",
  },
  {
    label: "Message Templates",
    route: "/message-templates",
    icon: faEnvelope,
    activeIcon: "",
  },
];

export default SideBarData;
